export default {"src":"/_next/static/media/Attom.db123901.svg","height":60,"width":60};